export default "__VITE_ASSET__BJPUECMH__"